var map = {
	"./backBanner.png": 1127,
	"./backBanner_pc.png": 1128,
	"./birthday_v1.png": 1210,
	"./birthday_v2.png": 1211,
	"./c_sv1.png": 1212,
	"./c_sv2.png": 1213,
	"./c_sv3.png": 1214,
	"./c_sv4.png": 1215,
	"./c_sv5.png": 1216,
	"./c_v1.png": 1217,
	"./c_v2.png": 1218,
	"./c_v3.png": 1219,
	"./c_v4.png": 1220,
	"./c_v5.png": 1221,
	"./c_v6.png": 1222,
	"./card1.png": 1223,
	"./cardBck.png": 1224,
	"./card_sv1.png": 1225,
	"./card_sv2.png": 1226,
	"./card_sv3.png": 1227,
	"./card_sv4.png": 1228,
	"./card_sv5.png": 1229,
	"./card_v1.png": 1230,
	"./card_v2.png": 1231,
	"./card_v3.png": 1232,
	"./card_v4.png": 1233,
	"./card_v5.png": 1234,
	"./card_v6.png": 1235,
	"./close.png": 1129,
	"./coupon-icon.png": 1116,
	"./coupons_v1.png": 1236,
	"./coupons_v2.png": 1237,
	"./d_sv1.png": 1238,
	"./d_sv2.png": 1239,
	"./d_sv3.png": 1240,
	"./d_sv4.png": 1241,
	"./d_sv5.png": 1242,
	"./d_v1.png": 1243,
	"./d_v2.png": 1244,
	"./d_v3.png": 1245,
	"./d_v4.png": 1246,
	"./d_v5.png": 1247,
	"./d_v6.png": 1248,
	"./dlock.png": 1249,
	"./exclusive_v1.png": 1250,
	"./exclusive_v2.png": 1251,
	"./fast_v1.png": 1252,
	"./fast_v2.png": 1253,
	"./game-logo.png": 1037,
	"./games/call-me-emperor.png": 1254,
	"./games/free-fire.png": 1255,
	"./games/game-of-khans.png": 1256,
	"./games/game-of-sultans.png": 1257,
	"./games/genshin.png": 1258,
	"./games/guardians-of-cloudia.png": 1259,
	"./games/hago.png": 1260,
	"./games/infinity-kingdom.png": 1261,
	"./games/infinity-war.png": 1262,
	"./games/kungfu-legend.png": 1263,
	"./games/lordsmobile.png": 1264,
	"./games/mobile-legends.png": 1265,
	"./games/pubgm.png": 1266,
	"./games/puzzles-survival.png": 1267,
	"./games/shining-nikki.png": 1268,
	"./games/soul-land3d.png": 1269,
	"./games/star-maker.png": 1270,
	"./games/state-of-survival.png": 1271,
	"./games/toplupe.png": 1272,
	"./games/turbo-vpn.png": 1273,
	"./games/vpn-proxy-master.png": 1274,
	"./kachshop.png": 1275,
	"./kb.png": 1117,
	"./kcoin-icon.png": 1118,
	"./kd_v1.png": 1276,
	"./kd_v2.png": 1277,
	"./l-0.png": 1278,
	"./l-1.png": 1279,
	"./lock.png": 1280,
	"./medal_svip1.png": 1077,
	"./medal_svip2.png": 1078,
	"./medal_svip3.png": 1079,
	"./medal_svip4.png": 1080,
	"./medal_svip5.png": 1081,
	"./medal_vip1.png": 1082,
	"./medal_vip2.png": 1083,
	"./medal_vip3.png": 1084,
	"./medal_vip4.png": 1085,
	"./medal_vip5.png": 1086,
	"./medal_vip6.png": 1087,
	"./mlbb.png": 1281,
	"./pleasantly_v1.png": 1282,
	"./pleasantly_v2.png": 1283,
	"./portrait_v1.png": 1284,
	"./portrait_v2.png": 1285,
	"./privilege.png": 1286,
	"./prop_v1.png": 1287,
	"./prop_v2.png": 1288,
	"./r-0.png": 1289,
	"./r-1.png": 1290,
	"./sv1.png": 1291,
	"./sv2.png": 1292,
	"./sv3.png": 1293,
	"./sv4.png": 1294,
	"./tcKgold.png": 1295,
	"./userinfo_bg.png": 1296,
	"./users.png": 1297,
	"./v1.png": 1298,
	"./v2.png": 1299,
	"./v3.png": 1300,
	"./v4.png": 1301,
	"./v5.png": 1302,
	"./v6.png": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1115;